import { Injectable } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';

import { DeleteAttachmentGQL, GetTaggableLogbookByIdGQL } from 'generated/graphql';

import { AttachmentsAPISerivce } from 'core/attachments-api.service';

@Injectable({ providedIn: 'root' })
export class TagFileAttachmentService {

  /**
   *
   */
  constructor(
    public attachmentsAPIService: AttachmentsAPISerivce,
    private deleteAttachmentGQL: DeleteAttachmentGQL,
    public getTagggableLogbookGQL: GetTaggableLogbookByIdGQL
  ) {
  }

  /**
   * Upload a file and attach it to a taggable logbook, and return updated
   * taggable logbook.
   *
   * @param file File to upload
   * @param taggableLogbookId id of logbook to attach file to
   *
   * Returns Tagabble Logbook Observable.
   */
  attachFileToTaggableLogbook(file: any, taggableLogbookId: string) {
    return this.attachmentsAPIService
      .attachFile(file, taggableLogbookId, 'TaggableLogbook').pipe(
        switchMap(
          (res) => this._fetchLogbook(res.attachable_id)
        )
      );
  }

  deleteFileFromTaggableLogbook(attachmentId: string, taggableLogbookId: string) {
    return this.deleteAttachmentGQL.mutate({ input: { attachmentId } }).pipe(
      switchMap(() => this._fetchLogbook(taggableLogbookId))
    );
  }


  private _fetchLogbook(taggableLogbookId: string) {
    return this.getTagggableLogbookGQL
      .fetch({ taggableLogbookId }, { fetchPolicy: 'network-only' })
      .pipe(
        map(({ data }) => data.getTaggableLogbookById)
      );
  }
}
